export default __webpack_public_path__ + "static/media/wdsjzs.ad5531c9.png";